import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <div className="min-h-screen mystical-bg py-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-heading font-bold golden-text text-glow uppercase tracking-widest mb-12 text-center">
            CONTACT
          </h1>
          
          <div className="text-center space-y-6">
            <p className="text-xl text-primary/80 leading-relaxed">
              For inquiries about the Shaktiverse, guidance, or technical support, reach out to us.
            </p>
            
            <div className="card-mystical rounded-2xl p-8 mt-8">
              <p className="text-primary/70 mb-2">Email</p>
              <p className="text-2xl font-heading text-primary">contact@shaktiverse.com</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;